import { render, staticRenderFns } from "./inc_menu.vue?vue&type=template&id=7f8bece4&scoped=true&"
import script from "./inc_menu.vue?vue&type=script&lang=js&"
export * from "./inc_menu.vue?vue&type=script&lang=js&"
import style0 from "./inc_menu.vue?vue&type=style&index=0&id=7f8bece4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8bece4",
  null
  
)

export default component.exports